import React, { useState } from 'react'; 
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button'; 
import 'dayjs/locale/ko';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'


import Draggable from 'react-draggable';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../common/dialog/BootstrapDialog';
import { useEffect } from 'react';
import FormLabel from '../common/form/FormLabel';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-bondDept-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const BondDeptModal = ({ data, open, handleClose, onSave }) => {
  const [exchangeProfit, setExchangeProfit] = useState(0);
  const [procPlanDt, setProcPlanDt] = useState(null);

  const renderTitle = data?.invTyp === '매출' ? '매출 수금' : '매입 지급';
  const renderMsg =
    data?.invTyp === '매출'
      ? `해당 매출 "${data?.invTxt}" 이 수금되었습니까?`
      : `해당 매입 "${data?.invTxt}" 를 지급하시겠습니까?`;

  const renderColor = data?.invTyp === '매출' ? 'success' : 'secondary';

  const onClose = () => {
    handleClose();
    setExchangeProfit(0);
    setProcPlanDt('');
  };

  useEffect(() => {
    setProcPlanDt(data?.procPlanDt);
  }, [data]);

  const chkValid = () => {
    if (procPlanDt === null || procPlanDt === '') {
      alert('지급(수금)예정 일자를 입력하세요');
      return false;
    }

    if (data.osTran === 'Y' && isNaN(exchangeProfit)) {
      alert('환차익은 숫자형식만 가능합니다.');
      return false;
    }
    return true;
  };

  const handleSave = () => {
    const chk = chkValid();
    if (chk) {
      onSave(
        {
          procCompYn: 'Y',
          // 완료일자(BITO_0425 p43/0515 p54 "완료일자 추가") — 지금 확정하는 시점을 완료일로 기록한다.
          procCompDt: dayjs().format('YYYY-MM-DD'),
          exchangeProfit,
          procPlanDt: dayjs(procPlanDt).format('YYYY-MM-DD'),
          invUuid: data?.invUuid,
        },
        renderTitle,
      );
      onClose();
    }
  };

  if (!data) {
    return null;
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-bondDept-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-bondDept-dialog"
        onClose={onClose}
      >
        {renderTitle}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Stack alignItems="center" sx={{ my: 1 }}>
          <Typography variant="subtitle2">{renderMsg}</Typography>
        </Stack>
        <Box sx={{ px: 2 }}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{
              py: 1,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item xs={4}>
              <FormLabel>
                지급(수금) 예정일자
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ mx: 1, color: 'error.main' }}
                >
                  (필수)
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={8}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  id="procPlanDt"
                  name="procPlanDt"
                  value={dayjs(procPlanDt)}
                  onChange={(newValue) => {
                    setProcPlanDt(dayjs(newValue));
                  }}
                  slotProps={{
                    textField: {
                      sx: { width: 180 },
                      variant: "outlined",
                      size: "small",
                      required: true,
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          {data?.osTran === 'Y' && (
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={4}>
                <FormLabel>환차익</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  size="small"
                  sx={{ width: 180 }}
                  value={exchangeProfit}
                  onChange={(e) => setExchangeProfit(e.target.value)}
                />
              </Grid>
            </Grid>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button color="default" variant="contained" onClick={onClose}>
          취소
        </Button>
        <Button variant="contained" color={renderColor} onClick={handleSave}>
          {renderTitle}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default BondDeptModal;
